import React, {useContext, useEffect, useState} from 'react';
import block from 'bem-cn-lite';
import {ToasterComponent, ToasterProvider} from '@gravity-ui/uikit';
import {Navigate, Outlet} from 'react-router-dom';
import {AppContext} from '../../app/context';
import {useTalkMe} from 'widgets';
import {ModalBannerNY} from '@components/ModalBannerNY';
import {
    shouldShowEDOBanner,
    shouldShowLateBanner,
    shouldShowNyBanner,
    shouldShowNyBannerByTime
} from '@utils';
import {hasPolicyConsent} from '@services/hasPolicyConsent';
import {ModalBannerPolicy} from '@components/ModalBannerPolicy';
// import {ModalBannerEDO} from '@components/ModalBannerEDO';
import {
    DocumentNotificationsProvider,
    DocumentNotificationsToastGate
} from '@components/DocumentNotifications';
import {CustomToaster} from '@app/Providers/CustomToasterProvider/CustomToaster';
// import {ModalBannerLate} from '@components/ModalBannerLate';

import './AuthWrapper.scss';

const b = block('auth-wrapper');

export const AuthWrapper: React.FC = () => {
    const context = useContext(AppContext);

    const [showBannerNY, setShowBannerNY] = useState(() => shouldShowNyBanner());
    // const [showBannerEDO, setShowBannerEDO] = useState(() => shouldShowEDOBanner());
    // const [showBannerLate, setShowBannerLate] = useState(() => shouldShowLateBanner());
    const [showPolicyModal, setShowPolicyModal] = useState(false);

    useTalkMe(context.state.user, context.state.clientDetails);

    useEffect(() => {
        if (!showBannerNY) return;

        const id = window.setInterval(() => {
            if (!shouldShowNyBannerByTime()) {
                setShowBannerNY(false);
                window.clearInterval(id);
            }
        }, 60_000);

        return () => window.clearInterval(id);
    }, [showBannerNY]);

    useEffect(() => {
        if (!context.state.token) return;

        if (!hasPolicyConsent()) {
            setShowPolicyModal(true);
        }
    }, [context.state.token]);

    if (!context.state.token) {
        return <Navigate to="/login" />;
    }

    return (
        <ToasterProvider>
            <DocumentNotificationsProvider>
                <div className={b()}>
                    <div className={b('container')}>
                        <Outlet />

                        <ModalBannerNY visibility={showBannerNY} stateModal={setShowBannerNY} />
                        <ModalBannerPolicy
                            visibility={showPolicyModal}
                            stateModal={setShowPolicyModal}
                        />
                        {/* <ModalBannerEDO visibility={showBannerEDO} stateModal={setShowBannerEDO} /> */}
                        {/* <ModalBannerLate
                            visibility={showBannerLate}
                            stateModal={setShowBannerLate}
                        /> */}

                        <DocumentNotificationsToastGate />
                    </div>
                </div>
                <CustomToaster />
            </DocumentNotificationsProvider>
        </ToasterProvider>
    );
};
